import { Component, OnInit, ElementRef  } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
declare var $: any;

@Component({
  selector: 'app-digital-courses-add',
  templateUrl: './college-courses-add.component.html',
  styleUrls: ['./college-courses-add.component.scss']
})
export class CollegeCourseComponent implements OnInit {

  public Form: FormGroup;
  public streams = [];
  public specializations = [];
  public courses = [];
  public colleges = [];
  public collegecourses = [];
  public message:any = null;
  public class:any = null;
  submitted = false;
  isShown: boolean = false ;
  action = null;
  collegeid = null;
  url = null;

  constructor(private el: ElementRef, private router: Router, private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute,) { }

  public settings = {
    actions: {
      position: 'right',
      add: false,
      edit: false,
      delete: true
    },
    delete :{
      confirmDelete: true
    },
    columns: {
      stream: {
        title: 'Streams'
      },
      course: {
        title: 'Courses'
      },
      specialization: {
        title: 'Specialization'
      },
      _id: {
        title:'Edit',
        type:'html',
        valuePrepareFunction:(cell,row)=>{
          return `<a href="college-details/edit-college-courses/${row._id}" class="ng2-smart-action ng2-smart-action-edit-edit ng-star-inserted"><i class="fa fa-pencil"></i></a>`;
        },
        filter:false
      },
    },
  };
  
  ngOnInit() {
   
    
    this.action = 'Add';
    let url = this.router.url.split('/');
    this.url = url[2];
    if(url[2] == 'college-courses'){
      this.ActivatedRoute.params.subscribe(params => {
        let id = params['id'];
        this.collegeid = id
        this.http.get<any>(`${environment.apiUrl}/collegecoursesByCollegeId/` + this.collegeid, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
          data => {
            (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
            this.collegecourses = data.data;
          },
          (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
      });
      
    }else{
      this.ActivatedRoute.params.subscribe(params => {
        let id = params['id'];
        
         this.http.get<any>(`${environment.apiUrl}/collegecoursesById/${id}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
          data => {
            (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
            if(data.data != ''){
              this.action = 'Update';
              this.Form.patchValue({
                _id               : data.data._id,
                streamid          : data.data.streamid,
                specializationid  : data.data.specializationid,
                courseid          : data.data.courseid,
                fees              : data.data.fees,
                scholarship       : data.data.scholarship,
                scholarshipamt    : data.data.scholarshipamt,
                duration          : data.data.duration,
                type              : data.data.type,
                award             : data.data.award,
              });
              this.collegeid = data.data.collegeid;
              if(data.data.scholarship == 'Enable'){
                this.isShown =  true;
              }else if(data.data.scholarship == 'Disable'){
                this.isShown =  false;
              }
              //get courses
              this.http.get<any>(`${environment.apiUrl}/collegecoursesByCollegeId/` + this.collegeid, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
                data => {
                  (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
                  this.collegecourses = data.data;
                },
                (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                  console.log("Client-side error occured.");
                } else {
                  console.log("Server-side error occured.");
                }
              });

              //get specialization
              this.http.get<any>(`${environment.apiUrl}/getByStream/${data.data.streamid}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
                data => {
                  (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
                  this.specializations = data.data;
              },
              (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                  console.log("Client-side error occured.");
                } else {
                  console.log("Server-side error occured.");
                }
              });

              //get course
              this.http.get<any>(`${environment.apiUrl}/getBySpecialization/${data.data.specializationid}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
                data => {
                  (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
                  this.courses = data.data;
              },
              (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                  console.log("Client-side error occured.");
                } else {
                  console.log("Server-side error occured.");
                }
              });
            }
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });

        
      });
    }
    
    
    this.Form = this.formBuilder.group({
      streamid: ['', Validators.required],
      specializationid: ['', Validators.required],
      courseid: ['', Validators.required],
      fees: ['', Validators.required],
      scholarship: ['', Validators.required],
      scholarshipamt: [''],
      _id: [''],
      duration: ['', Validators.required],
      type: ['', Validators.required],
      award: ['', Validators.required],
    }); 

    this.http.get<any>(`${environment.apiUrl}/stream`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          this.streams = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    
  }

  getcourses(value){
    this.http.get<any>(`${environment.apiUrl}/getBySpecialization/${value}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          this.courses = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  getspecialization(value){
    this.http.get<any>(`${environment.apiUrl}/getByStream/${value}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          this.specializations = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  scholarshipamt(value){
    if(value == 'Enable'){
      this.isShown =  true;
    }else if(value == 'Disable'){
      this.isShown =  false;
    }
  }

  get f() { return this.Form.controls; }
  
  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      console.log(this.Form.controls);
      return;
    }
  
    if(this.action == 'Add'){
      let data = {
        "streamid"            : this.Form.value.streamid,
        "courseid"            : this.Form.value.courseid,
        "specializationid"    : this.Form.value.specializationid,
        "fees"                : this.Form.value.fees,
        "scholarship"         : this.Form.value.scholarship,
        "scholarshipamt"      : this.Form.value.scholarshipamt,
        "collegeid"           : this.collegeid,
        "duration"            : this.Form.value.duration,
        "type"                : this.Form.value.type,
        "award"               : this.Form.value.award,
        "userid"              : localStorage.getItem('userId'),
      };  
      this.http.post<any>(`${environment.apiUrl}/collegecourses/`, data, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        res => {
          (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          if(res.status == '500'){
            this.message = res.message;
            this.class = 'btn-primary rounded px-1 py-1';
            window.scrollTo(document.documentElement.clientWidth, 0);
            return 0;
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn-success rounded px-1 py-1';
            this.ngOnInit();
          } 
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else{
      let data = {
        "streamid"            : this.Form.value.streamid,
        "courseid"            : this.Form.value.courseid,
        "specializationid"    : this.Form.value.specializationid,
        "fees"                : this.Form.value.fees,
        "seats"               : this.Form.value.seats,
        "scholarship"         : this.Form.value.scholarship,
        "scholarshipamt"      : this.Form.value.scholarshipamt,
        "_id"                 : this.Form.value._id,
        "collegeid"           : this.collegeid,
        "duration"            : this.Form.value.duration,
        "type"                : this.Form.value.type,
        "award"               : this.Form.value.award,
        "userid"              : localStorage.getItem('userId'),
      };
      
      this.http.put<any>(`${environment.apiUrl}/collegecourses/`, data, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      res => {
        (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
        if(res.status == '500'){
          this.message = res.message;
          this.class = 'btn-primary rounded px-1 py-1';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return 0;
        }else{
          this.message = 'Successfully Updated';
          this.class = 'btn-success rounded px-1 py-1';
          this.router.navigateByUrl('/college-details/college-courses/' + this.collegeid);
        } 
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

  deleteRecord(event){
    if(confirm('Are You Sure?')){
      this.http.delete<any>(`${environment.apiUrl}/collegecourses/${event.data._id}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          if(data.status == '500'){
            this.message = data.message;
            this.class = 'btn-primary rounded px-1 py-1';
            window.scrollTo(document.documentElement.clientWidth, 0);
            return 0;
          }else{
            this.message = 'Successfully Deleted';
            this.class = 'btn-success rounded px-1 py-1';
            this.ngOnInit();
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
